import { Component, OnInit } from '@angular/core';
import { NewEnvelopeService } from 'src/app/envelope/new-envelope/new-envelope.service';
import { NewEnvelopeSteps } from 'src/app/enum/new-envelope-steps';

@Component({
  selector: 'envelope-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss']
})
export class ReviewComponent implements OnInit {

  stepInformation: any;
  authorizer: boolean;
  hasObservers: boolean;
  hasResponsibles: boolean;

  constructor(private newEnvelopeService: NewEnvelopeService) { }

  ngOnInit() {
    this.stepInformation = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Signatory);
    this.authorizer = this.stepInformation['authorizer'];
    this.hasObservers = this.stepInformation['envelopeObserver'].length > 0;
    this.hasResponsibles = this.stepInformation['envelopeResponsible']?.length > 0;
  }
}
